import { applySnapshot, types, flow } from 'mobx-state-tree'
import { apiV1 } from 'utils'

export const BankPasswordsStore = types
  .model('BankPasswordStore', {
    _list: types.optional(types.array(types.frozen()), []),
    _password: types.maybeNull(types.frozen()),
    _pendingCount: 0, // <--- глобальный счётчик загрузок
  })

  .views(self => ({
    get isPending() {
      return self._pendingCount > 0
    },

    get list() {
      return self._list
    },

    get password() {
      return self._password
    },
  }))

  .actions(self => ({
    startPending() {
      self._pendingCount++
    },

    endPending() {
      self._pendingCount = Math.max(0, self._pendingCount - 1)
    },

    setList(list) {
      applySnapshot(self._list, list ?? [])
    },

    setPassword(data) {
      self._password = data ? { ...data } : null
    },

    // 📌 Получить список паролей
    getList: flow(function* (bankKeyId = null) {
      self.startPending()
      try {
        const res = yield apiV1.get('/BankPasswords', {
          params: { bankKeyId },
        })
        self.setList(res.data)
        return res.data
      } finally {
        self.endPending()
      }
    }),

    // 📌 Получить пароль по id
    getPasswordById: flow(function* (id) {
      self.startPending()
      try {
        const res = yield apiV1.get(`/BankPasswords/${id}`)
        self.setPassword(res.data)
        return { ...res.data }
      } catch (err) {
        console.error('getPasswordById error', err)
        return null
      } finally {
        self.endPending()
      }
    }),

    // 📌 Добавить пароль
    addPassword: flow(function* (data) {
      self.startPending()
      try {
        const res = yield apiV1.post('/BankPasswords', data)
        return res.data
      } finally {
        self.endPending()
      }
    }),

    // 📌 Изменить пароль
    editPassword: flow(function* (data) {
      self.startPending()
      try {
        const res = yield apiV1.put('/BankPasswords', data)
        return res.data
      } finally {
        self.endPending()
      }
    }),

    // 📌 Скрыть пароль
    hidePassword: flow(function* (id) {
      self.startPending()
      try {
        const res = yield apiV1.patch(`/BankPasswords/${id}/Hide`)
        return res.data
      } finally {
        self.endPending()
      }
    }),

    // 📌 Общий метод смены пароля
    changePassword: flow(function* (data) {
      self.startPending()
      try {
        const res = yield apiV1.put('/setPassword', data)
        return res.data
      } finally {
        self.endPending()
      }
    }),
  }))

export default BankPasswordsStore
